export const CONSTRUCTION = {
  value: 'Rehab_85_LTC',
  name: 'Construction',
};

export const FIX_FLIP = {
  value: 'fix_and_flip',
  name: 'Fix & Flip',
};

export const RESIDENTIAL = {
  value: 'residential_bridge',
  name: 'Bridge',
};

export const COMMERCIAL = {
  value: 'commercial',
  name: 'Multi-Family/CRE',
};

export const LAND = {
  value: 'land',
  name: 'Land',
};

export const TDS = {
  value: 'td_2nd_3rd',
  name: "2nd/3rd TD's",
};

const typeOfHomeOptions = [CONSTRUCTION, FIX_FLIP, RESIDENTIAL, COMMERCIAL, LAND, TDS];

export default typeOfHomeOptions;



// WEBPACK FOOTER //
// ./src/constants/typeOfHomeOptions.js